<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Atajos</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <div class="table-responsive">
          <table class="text-center">
            <thead>
              <tr>
                <th>Atajo</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(atajo, index) in atajos" :key="index">
                <td>
                  {{ atajo.value }}
                </td>
                <td>
                  {{ atajo.descripcion }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i>
        <span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
export default {
  props: {
    atajos: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {
      
    };
  },
  methods: {
    cerrar: function () {
      this.$emit("cerrar");
    },
  },
  mounted: function () {},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/sistema/Atajos.vue